import ufeApi from 'services/api/ufeApi';
// import RCPSCookies from 'utils/RCPSCookies';

async function getPostsNextPage(creatorHandle, nextPage) {
    const url = `/gway/v1/creator-storefront/creators/${creatorHandle}/posts/page/${nextPage}`;

    const headers = {
        'Content-Type': 'application/json',
        'X-Api-Key': Sephora.sdnUfeAPIUserKey
    };

    try {
        // Making the GET request without the request body
        const data = await ufeApi.makeRequest(url, {
            method: 'GET',
            headers
        });

        // Check for error code in the response
        if (data?.fault || data?.responseStatus !== 200) {
            return Promise.reject(data.fault);
        }

        return {
            data,
            headers: {}
        };
    } catch (error) {
        Sephora.logger.verbose('Failed to fetch Posts Next Page data:', error);

        return Promise.reject(error);
    }
}

export default getPostsNextPage;
